import { AsyncStorage } from '@pletly/common';

const LAST_EMAIL_STORAGE_KEY = 'lastLoginEmail';

function rememberEmail(email?: string) {
	if (!email) {
		return;
	}

	return AsyncStorage.setStorageItem(LAST_EMAIL_STORAGE_KEY, email.trim());
}

function getLastEmail() {
	return AsyncStorage.getString(LAST_EMAIL_STORAGE_KEY);
}

export { rememberEmail, getLastEmail };
